import { defineMessages, useIntl } from 'react-intl'
import { Card, CardBody, Avatar, Text } from '@homebotapp/hb-react-component-catalog'
import { selectCustomerFirstName, selectCustomerPhotoUri } from '../../../../store/selectors/customerProfile'
import { useAppSelector } from '../../../../store/hooks'

export const MSG = defineMessages({
  notify: {
    id: 'TYV.valuation.request.cma.notification',
    defaultMessage: "We'll notify {customer} to check and see if this looks right for your area"
  }
})

export const RequiredCmaNotification = () => {
  const intl = useIntl()
  const customerFirstName = useAppSelector(selectCustomerFirstName)
  const photoUrl = useAppSelector(selectCustomerPhotoUri)

  return (
    <Card mt={8} mb={4}>
      <CardBody display='flex' textAlign='left'>
        <Avatar mr={2} alignSelf='center' src={photoUrl} />
        <Text alignSelf='center' mb={0}>
          {intl.formatMessage(MSG.notify, { customer: customerFirstName })}
        </Text>
      </CardBody>
    </Card>
  )
}
